/**
 * Bible reference formatting — human-readable verse and chapter references.
 */
import { getBookInfo } from '../constants/toc.js';
/**
 * Format a Bible location as a human-readable reference.
 * e.g., "John 3:16" or "Genesis 1:1"
 */
export function formatReference(location) {
    const book = getBookInfo(location.testamentIndex, location.bookIndex);
    if (!book)
        return 'Unknown';
    const chapter = location.chapterIndex + 1;
    const verse = location.verseIndex + 1;
    return `${book.name} ${chapter}:${verse}`;
}
/**
 * Format a Bible location as chapter-only reference (no verse).
 * e.g., "John 3" or "Genesis 1"
 */
export function formatChapterReference(location) {
    const book = getBookInfo(location.testamentIndex, location.bookIndex);
    if (!book)
        return 'Unknown';
    const chapter = location.chapterIndex + 1;
    return `${book.name} ${chapter}`;
}
/**
 * Format a Bible location as abbreviated chapter-only reference.
 * e.g., "Gen 1", "1 Th 3" — used in mobile toolbar.
 */
export function formatAbbrevChapterReference(location) {
    const book = getBookInfo(location.testamentIndex, location.bookIndex);
    if (!book)
        return 'Unknown';
    const chapter = location.chapterIndex + 1;
    return `${book.abbrev} ${chapter}`;
}
/**
 * Format a Bible location as a short reference.
 * e.g., "Jhn 3:16" or "Gen 1:1"
 */
export function formatShortReference(location) {
    const book = getBookInfo(location.testamentIndex, location.bookIndex);
    if (!book)
        return 'Unknown';
    const chapter = location.chapterIndex + 1;
    const verse = location.verseIndex + 1;
    return `${book.abbrev} ${chapter}:${verse}`;
}
//# sourceMappingURL=format-reference.js.map